const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ACTORS_CATEGORIES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ACTORS_CATEGORIES_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "ACTORS_CATEGORIES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
